import React from 'react'
import App from '../App'
import Home from '../pages/Home'
import Cartoon from "../pages/Cartoon";
import Dispute from '../pages/Dispute'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { createHashHistory } from "history";
const history = createHashHistory();

class RouterConfig extends React.Component {
  render() {
    return (
      <Router history={history}>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="cartoon" element={<Cartoon />} />
            <Route path="dispute" element={<Dispute />} />
            <Route path="*" element={<Navigate to="home" />} />
          </Route>
        </Routes>
      </Router>
    );
  }
}
export default RouterConfig
